module.exports = __webpack_public_path__ + "img/product.53a0aa04.png";